<template>
  <div>
    <b-container fluid class="content menupage">
      <b-alert
        :show="countdown"
        dismissible
        variant="success"
        @dismissed="countdown = 0"
        @dismiss-count-down="close_alert"
        class="show_alert"
      >
        {{ dismessage }}
      </b-alert>
      <b-card>
        <b-row>
          <b-col cols="12">
            <el-form ref="form">
              <b-row class="mb-0">
                <b-col cols="3">
                  <el-form-item size="mini" :label="$t('Name') + '1'">
                    <el-input
                      placeholder="Name1"
                      v-model="cur_menu.Name1"
                      @change="change_cur_menu()"
                      class="w-50"
                      size="mini"
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col cols="3">
                  <el-form-item size="mini" :label="$t('Name') + '2'">
                    <el-input
                      placeholder="Name2"
                      v-model="cur_menu.Name2"
                      @change="change_cur_menu()"
                      class="w-50"
                      size="mini"
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col cols="3">
                  <el-form-item size="mini" :label="$t('Price')">
                    <el-select
                      size="mini"
                      class="w-50"
                      v-model="cur_menu.PriceGroup"
                      placeholder="Price Group"
                      @change="change_cur_menu()"
                    >
                      <el-option label="A" value="A"></el-option>
                      <el-option label="B" value="B"></el-option>
                      <el-option label="C" value="C"></el-option>
                      <el-option label="D" value="D"></el-option>
                      <el-option label="E" value="E"></el-option>
                      <el-option label="F" value="F"></el-option>
                      <el-option label="G" value="G"></el-option>
                      <el-option label="H" value="H"></el-option>
                      <el-option label="I" value="I"></el-option>
                      <el-option label="J" value="J"></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col cols="3">
                  <el-form-item size="mini" :label="$t('Start Date')">
                    <el-date-picker
                      v-model="cur_menu.StartDate"
                      @change="change_cur_menu()"
                      type="date"
                      size="mini"
                      class="widthdate"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placement="bottom-start"
                      placeholder="Pick a day">
                    </el-date-picker>
                  </el-form-item>
                </b-col>
                <b-col cols="3">
                  <el-form-item size="small" :label="$t('End Date')">
                    <el-date-picker
                      v-model="cur_menu.EndDate"
                      @change="change_cur_menu()"
                      type="date"
                      size="mini"
                      class="widthdate"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placement="bottom-start"
                      placeholder="Pick a day">
                    </el-date-picker>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col cols="1" class="mb-3">
                  {{ $t("Available") }}
                </b-col>
                <b-col class="mb-3">
                  <el-checkbox-group v-model="cur_menu.LocationID" @change="change_cur_menu">
                    <el-checkbox v-for="st in storelist" :key="st.LocationID" :label="st.LocationID">{{ st.LocationID  + " - " + st.LocationName }}</el-checkbox>
                  </el-checkbox-group>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col cols="3" class="mb-3">
                  <el-switch
                    size="mini"
                    v-model="cur_menu.mustHave"
                    :width="30"
                    :active-value="1"
                    :inactive-value="0"
                    @change="change_cur_menu()"
                  ></el-switch>
                  <span class="ml-1">{{ $t("Items Check") }}</span>
                </b-col>
                <b-col cols="3">
                  <el-form-item v-if="cur_menu.mustHave==1" size="mini" :label="$t('Items Check Start')">
                    <el-select
                      size="mini"
                      class="w-50"
                      v-model="cur_menu.mustHaveStart"
                      placeholder="Start Time"
                      @change="change_cur_menu()"
                    >
                      <el-option v-for="tm in tmlist" :key="tm" :label="tm" :value="tm"></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col cols="3">
                  <el-form-item v-if="cur_menu.mustHave==1" size="small" :label="$t('Items Check End')">
                    <el-select
                      size="mini"
                      class="w-50"
                      v-model="cur_menu.mustHaveEnd"
                      placeholder="End Time"
                      @change="change_cur_menu()"
                    >
                      <el-option v-for="tm in tmlist" :key="tm" :label="tm" :value="tm"></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col cols="3">
                  <el-form-item v-if="cur_menu.mustHave==1" size="mini" :label="$t('Items Check Remind')">
                    <el-input
                      placeholder="Items Check Remind"
                      v-model="cur_menu.mustHaveWarrning"
                      @change="change_cur_menu()"
                      class="w-50"
                      size="mini"
                    ></el-input>
                  </el-form-item>
                </b-col>
              </b-row>
              <hr class="page_hr" />
              <b-row class="mb-1">
                <b-col cols="3">
                  <el-switch
                    size="mini"
                    v-model="cur_menu.IsEMenu"
                    :width="30"
                    :active-value="1"
                    :inactive-value="0"
                    @change="change_cur_menu"
                  ></el-switch>
                  <span class="ml-1">H5&EMenu&Kiosk</span>
                </b-col>
              </b-row>
              <b-row class="mb-1 mt-1" v-if="cur_menu.IsEMenu==1">
                <b-col cols="3">
                  <el-switch
                    size="mini"
                    v-model="cur_menu.menuTimeControl"
                    :width="30"
                    :active-value="1"
                    :inactive-value="0"
                    @change="change_cur_menu()"
                  ></el-switch>
                  <span class="ml-1">{{ $t("EMenu&Kiosk Time Control") }}</span>
                </b-col>
                <b-col cols="3">
                  <el-form-item size="mini" :label="$t('Start Time')">
                    <el-select
                      size="mini"
                      class="w-50"
                      v-model="cur_menu.menuStart"
                      placeholder="Start Time"
                      @change="change_cur_menu()"
                    >
                      <el-option v-for="tm in tmlist" :key="tm" :label="tm" :value="tm"></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col cols="3">
                  <el-form-item size="small" :label="$t('End Time')">
                    <el-select
                      size="mini"
                      class="w-50"
                      v-model="cur_menu.menuEnd"
                      placeholder="End Time"
                      @change="change_cur_menu()"
                    >
                      <el-option v-for="tm in tmlist" :key="tm" :label="tm" :value="tm"></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col cols="3">
                  <el-tooltip content="1: first use, 9:last use" placement="top">
                    <el-form-item size="mini" :label="$t('Sequence')">
                      <el-input
                        placeholder="EMenu Sequence"
                        v-model="cur_menu.menuOrder"
                        @change="change_cur_menu()"
                        class="w-50"
                        size="mini"
                      ></el-input>
                    </el-form-item>
                  </el-tooltip>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col cols="4" class="mb-1">
                </b-col>
                <b-col cols="6" class="mb-1">
                  <el-button type="primary" @click="cancel_change()" >{{ $t('Cancel Change') }}</el-button>
                  <el-button type="primary" class="ml-6" @click="save_change()" >{{ $t('Save Change') }}</el-button>
                </b-col>
              </b-row>
            </el-form>
          </b-col>
        </b-row>
        <hr class="page_hr mt-4" />
        <hr class="page_hr mt-1" />
        <div class="mt-2"><b>{{ $t('Cloud Store Setting') }}( Following changes to the settings will take effect immediately. )</b></div>
        <b-row>
          <b-col cols="10">
            <b-row>
              <b-col cols="12" v-for="(store, idx) in onlineStoreList" :key="idx">
                <b-row v-if="store.RowType" class="mt-2">
                  <b-col cols="12">
                    {{ store.LocationName }}
                    <span class="ml-3" v-if="store.RowType!='H'">
                      ( Please enable this menu to this store or set up online stores on store setting )
                    </span>
                  </b-col>
                </b-row>
                <b-row v-else class="mt-1">
                  <b-col cols="3" class="text-right">
                    {{ getSourceName(store.SourceType) }}
                  </b-col>
                  <b-col cols="3">
                    <span class="ml-1 mr-3"> </span>
                    <el-switch
                      size="mini"
                      v-model="store.selected"
                      :width="30"
                      :active-value="1"
                      active-color="#13ce66"
                      :inactive-value="0"
                      inactive-color="#ff4949"
                      @change="(newValue) => save_online_source(store, 'menu')"
                    ></el-switch>
                    <span class="ml-1 mr-3">{{ $t("Use this Menu") }}</span>
                  </b-col>
                  <b-col v-if="(store.SourceType=='pandaapi')||(store.SourceType=='ubereat')" cols="3">
                    <el-switch
                      size="mini"
                      v-model="store.AutoConfirm"
                      :width="30"
                      :active-value="1"
                      active-color="#13ce66"
                      :inactive-value="0"
                      inactive-color="#ff4949"
                      @change="(newValue) => save_online_source(store, 'confirm')"
                    ></el-switch>
                    <span class="ml-1 mr-3">{{ $t("Auto-Confirm") }}</span>
                  </b-col>
                  <!-- <b-col cols="3">
                    <b-form-select v-model="store.IDn" class="mb-3" size="sm" @change="change_cur_menu()">
                      <b-form-select-option value="-1">Not </b-form-select-option>
                      <b-form-select-option v-for="(ostore, idx) in onlineList[store.LocationID]" :key="idx" :value="ostore.IDn">
                        {{ ostore.SourceType }}
                      </b-form-select-option>
                    </b-form-select>
                  </b-col> -->
                  <b-col cols="3" v-if="(store.IDn>0)&&store.selected&&((store.SourceType=='pandaapi')||(store.SourceType=='ubereat'))&&!isChanged">
                    <el-button
                      class="upload_Online"
                      @click="upload_online($event, store)"
                      size="mini"
                      type="primary"
                    >{{ $t("Update Online Menu") }}</el-button>
                  </b-col>
                  <b-col cols="3" v-else-if="(store.IDn>0)&&store.selected&&(store.SourceType=='poskingh5')&&!isChanged">
                    <el-button
                      class="upload_Online"
                      @click="upload_ldw()"
                      size="mini"
                      type="primary"
                    >Upload Menu Images</el-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <b-col v-if="menulist">
            <div class="pb-2 border-bottom">
              {{ $t('Sort') }}
            </div>
            <b-row v-for="(menu, idx) in menulist" :key="idx" class="border-bottom">
              <b-col class="menu-sort-block">
                <div class="opt-class" @click="move_action(idx, -1)">&uarr;</div>
                <div class="name-class">{{ menu.Name1 }}</div>
                <div class="opt-class" @click="move_action(idx, 1)">&darr;</div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
    </b-container>
    <el-dialog title="Upload Image File" :visible.sync="upload_product_dialog" width="30%">
      <div class="upload_product_div" id="upload_product_ref">
        <div v-for="(row,idx) in upload_file_list" :key="idx">{{ row }}</div>
      </div>
      <div slot="footer">
        <el-button v-if="upload_show_close" @click="upload_product_dialog = false">OK</el-button>
      </div>
    </el-dialog>
    <vue-element-loading
      :active="showloading"
      spinner="bar-fade-scale"
      color="#FF6700"
      duration="2.0"
      background-color="rgba(255, 255, 255, .5)"
      size="100"
    />
  </div>
</template>
<script>
import {
  Form,
  Tabs,
  TabPane,
  Button,
  Checkbox,
  CheckboxGroup,
  FormItem,
  Select,
  Option,
  InputNumber,
  Tag,
  Switch,
  Row,
  Dialog,
  Col,
  Radio,
  RadioGroup,
  ColorPicker,
  DatePicker,
} from "element-ui";
import "flatpickr/dist/flatpickr.css";
import MenuBtn from "../Components/MenuBtn";
import MenuTemplate from "../Components/MenuTemplate";
import { getStore, setStore } from "../../util/helper";
import VueElementLoading from "vue-element-loading";
// import { XlsxRead, XlsxWorkbook, XlsxSheet, XlsxDownload } from "vue-xlsx";

const axios = require("axios");

export default {
  components: {
    [Form.name]: Form,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [FormItem.name]: FormItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [InputNumber.name]: InputNumber,
    [Tag.name]: Tag,
    [Switch.name]: Switch,
    [Row.name]: Row,
    [Dialog.name]: Dialog,
    [Col.name]: Col,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [ColorPicker.name]: ColorPicker,
    [DatePicker.name]: DatePicker,
    VueElementLoading,
  },
  data() {
    return {
      showloading: false,
      isChanged: false,
      cur_idx: 1,       // Right menu key index, for drew control

      tmlist: [
        '00:00','00:30',
        '01:00','01:30',
        '02:00','02:30',
        '03:00','03:30',
        '04:00','04:30',
        '05:00','05:30',
        '06:00','06:30',
        '07:00','07:30',
        '08:00','08:30',
        '09:00','09:30',
        '10:00','10:30',
        '11:00','11:30',
        '12:00','12:30',
        '13:00','13:30',
        '14:00','14:30',
        '15:00','15:30',
        '16:00','16:30',
        '17:00','17:30',
        '18:00','18:30',
        '19:00','19:30',
        '20:00','20:30',
        '21:00','21:30',
        '22:00','22:30',
        '23:00','23:30',
        '24:00',
      ],

      upload_product_dialog: false,
      upload_file_ids: [],
      upload_file_cnt: 0,
      upload_file_list: [],
      upload_show_close: false,

      showLanguage: "1",

      cur_menu: {   // Menu Meta Data Record
        IDn: "",
        Name1: "",
        Name2: "",
        Remarks: "",
        PanelWidth: 674,
        PanelHeigh: 663,
        DepartmentHeight: 39,
        CategoryHeight: 117,
        ProductHeight: 507,
        DepartmentRow: 1,
        DepartmentColumn: 5,
        DepartmentFontSize: 14,
        DepartmentFontWeight: 400,
        DepartmentFontColor: '#000000',
        CategoryRow: 3,
        CategoryColumn: 5,
        CategoryFontSize: 14,
        CategoryFontWeight: 400,
        CategoryFontColor: '#000000',
        ProductRow: 5,
        ProductColumn: 5,
        ProductFontSize: 14,
        ProductFontWeight: 400,
        ProductFontColor: '#000000',
        PriceGroup: "A",
        LocationID: [],
        TaxGroupIDn: [],
        HourTable: "",
        IsOnline: 0,
        IsEMenu: 0,
        StartDate: "2021-01-01",
        EndDate: "2031-01-01",
        Status: 1,
        menuOrder: 10,
        menuTimeControl: 0,
        menuStart: '',
        menuEnd: '',
        mustHave: 0,
        mustHaveStart: '',
        mustHaveEnd: '',
        mustHaveWarrning: '',
      },
      cur_product: {
        Name1: "",
        Name2: "",
      },
      curmenu_product: {
        Price: 0,
        DiscountPrice: 0,
        BtnColor: "#cad1d7",
        Quantity: 1000,
        SortOrder: 999,
        Soldout: 1,
      },

      menulist: null,                 // All Menu basic record list
      fulllist: null,                 // Array structure!! All Product list under sorted department and category
      leftcategory: null,             // pointer!! Left active category pointer
      leftproduct: null,
      curmenu_departmentlist: [],   // Array structure!! Right Menu Structed data list and for for department display
      curmenu_categorylist: [],     // pointer!! Right Menu for category display
      curmenu_productlist: [],      // pointer!! Right Menu for product display

      cur_MenuIDn: 0,           // Active Menu IDn
      cur_DepartmentIDn: 0,     // Selected Department IDn, For display css control
      cur_CategoryIDn: 0,       // Selected Category IDn, For display css control
      cur_ProductIDn: 0,        // Selected Product IDn, For display css control

      storelist: [],
      onlineStoreList: [],
      onlineList: [],

      cur_operating: 0,        // 0: no operating; 1: try to add other product to current category; 2: Change Button Color;

      Original_DepartmentIDn: 0,
      Original_CategoryIDn: 0,

      dismessage: "",
      countdown: 0,

      PanelWidth: 690,  // Add scroll bar 674 + 6
      PanelHeigh: 665,  // Add divider bar 663 + 2

      menuDeptBtnWidth: 151,
      menuDeptBtnHeight: 60,
      menuDeptBtnFontSize: 16,
      menuDeptBtnFontWeight: 400,
      menuDeptBtnFontColor: "#7BF58D",
      menuCateBtnWidth: 200,
      menuCateBtnHeight: 100,
      menuCateBtnFontSize: 16,
      menuCateBtnFontWeight: 400,
      menuCateBtnFontColor: "#7BF58D",
      menuProdBtnWidth: 200,
      menuProdBtnHeight: 100,
      menuProdBtnFontSize: 16,
      menuProdBtnFontWeight: 400,
      menuProdBtnFontColor: "#7BF58D",

      btnToColor: "#FFDAB8",
      btnDToColor: "#FFCE76",
      btnCToColor: "#FF865B",
      btnPToColor: "#FFDAB8",

      department_list_size: { width: '690px', height: '39px',},
      category_list_size: { width: '690px', height: '117px',},
      product_list_size: { width: '690px', height: '500px',},
      btnselectstyle: { backgroundColor: "#cad1d7" },
      panel_left: { width: '116px'},

      movingtype: null,
      movingevt: null,
      movingprod: null,
      movingleft: 0,
      movingtop: 0,

      sync_to_server: null,

      new_menu_department: {
        IDn: 0,
        Name1: "",
        Name2: "",
        MenuIDn: 0,
        DepartmentIDn: 0,
        Categorys: [],
        BtnColor: '#FFCE76',
        SortOrder: 999,
      },
      new_menu_category: {
        IDn: 0,
        Name1: "",
        Name2: "",
        MenuIDn: 0,
        DepartmentIDn: 0,
        CategoryIDn: 0,
        Products: [],
        BtnColor: '#FF865B',
        SortOrder: 999,
      },
      new_menu_product: {
        IDn: 0,
        Name1: "",
        Name2: "",
        MenuIDn: 0,
        DepartmentIDn: 0,
        CategoryIDn: 0,
        ProductIDn: 0,
        AltCategoryIDn: 0,
        BtnColor: '#FFDAB8',
        SortOrder: 999,
      },

      templateList: [
        { department: '#FFCE76', category: '#FF865B', product: '#FFDAB8' },
        { department: '#D96A29', category: '#D99E6A', product: '#BAD9D3' },
        { department: '#D49B57', category: '#D9BF5D', product: '#D18354' },
        { department: '#E7A97A', category: '#E59578', product: '#DBB57B' },
        { department: '#63D6A1', category: '#DFC87E', product: '#CB9C8A' },
        { department: '#F2B8A4', category: '#F2DBB4', product: '#F7EBD9' },
        { department: '#F6AB8E', category: '#FFCDB6', product: '#FFE1DB' },
        { department: '#A8D6E5', category: '#D2E9E3', product: '#E5EFF0' },
        { department: '#D7D1DF', category: '#CDB1D8', product: '#DBD5F9' },
        { department: '#6B94F3', category: '#7AC4F5', product: '#BCA8D7' },
        { department: '#5ECDD9', category: '#64D8A2', product: '#79B8E8' },
      ],
      showTemplateList: false,

      pkadmin: false,

      token: "",
      user_id: 0,

      // export
      export_sheets_for_menu: [{ name: "menu", data: [[1,2,3,4],[5,6,7,8]] }],
      callback_for_menu: "",
      export_filename: "",
      // import
      import_file: null,
      import_overwrite: 0,
      overwrite_Menu_IDn: 0,
    };
  },
  computed: {},
  watch: {
    // cur_MenuIDn: function (nval, oval) {
    // },
  },
  methods: {
    // Drop All Changes and get Current Menu again
    cancel_change() {
      if (!this.isChanged || confirm("You have made some changes, do you want to drop it?")) {
        this.$router.push("/menu");
      }
    },
    // Confirm all Changes and get Current Menu again
    save_change() {
      if (!this.isChanged) {
        this.$router.push("/menu");
      }
      this.showloading = true;
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("MenuIDn", this.cur_MenuIDn);
      bodyFormData.append("Menu", JSON.stringify(this.cur_menu));

      var that = this;
      axios({
        method: "post",
        url: "/Api/Web/menu/save_menu",
        data: bodyFormData,
      })
        .then(function (response) {
          that.showloading = false;
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.cur_MenuIDn = rt.data.MenuIDn;
              that.$router.push("/menu");
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          that.showloading = false;
          // console.log(error);
          that.$router.push("/login");
        });
    },
    save_online_source(store, op) {
      if (op == "menu") {
        const store_selected = store.selected?0:1;
        if (!confirm("Are you sure you want to change this?")) {
          store.selected = store_selected;
          return;
        }
        if (store.selected) {
          store.Menu_IDn = this.cur_MenuIDn;
        } else {
          store.Menu_IDn = 0;
        }
      }
      this.showloading = true;
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("OnlineStore", JSON.stringify(store));

      var that = this;
      axios({
        method: "post",
        url: "/Api/Web/menu/save_online_source",
        data: bodyFormData,
      })
        .then(function (response) {
          that.showloading = false;
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              // that.$router.push("/menu");
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          that.showloading = false;
          // console.log(error);
          that.$router.push("/login");
        });
    },
    close_alert() {
      this.countdown = 0;
      if (this.countdown == 0) {
        this.dismessage = "";
      }
    },
    getSourceName(type) {
      if (type == "pandaapi") {
        return "Panda API";
      } else if (type == "poskingh5") {
        return "Posking LDW";
      } else if (type == "pkh5") {
        return "Posking Cloud";
      } else if (type == "ubereat") {
        return "Uber Eat";
      } else {
        return "Unknown";
      }
    },
    // For convert data to good data type
    format_meun(menu) {
      menu.PanelWidth = parseInt(menu.PanelWidth);
      menu.PanelHeigh = parseInt(menu.PanelHeigh);
      menu.DepartmentHeight = parseInt(menu.DepartmentHeight);
      menu.CategoryHeight = parseInt(menu.CategoryHeight);
      menu.ProductHeight = parseInt(menu.ProductHeight);
      menu.DepartmentRow = parseInt(menu.DepartmentRow);
      menu.DepartmentColumn = parseInt(menu.DepartmentColumn);
      menu.DepartmentFontSize = parseInt(menu.DepartmentFontSize);
      menu.DepartmentFontWeight = parseInt(menu.DepartmentFontWeight);
      menu.CategoryRow = parseInt(menu.CategoryRow);
      menu.CategoryColumn = parseInt(menu.CategoryColumn);
      menu.CategoryFontSize = parseInt(menu.CategoryFontSize);
      menu.CategoryFontWeight = parseInt(menu.CategoryFontWeight);
      menu.ProductRow = parseInt(menu.ProductRow);
      menu.ProductColumn = parseInt(menu.ProductColumn);
      menu.ProductFontSize = parseInt(menu.ProductFontSize);
      menu.ProductFontWeight = parseInt(menu.ProductFontWeight);
      menu.IsOnline = parseInt(menu.IsOnline);
      menu.IsEMenu = parseInt(menu.IsEMenu);
      menu.mustHave = parseInt(menu.mustHave);
      menu.menuTimeControl = parseInt(menu.menuTimeControl);
      menu.menuOrder = parseInt(menu.menuOrder);
      let onlineStores = [];
      for (let i=0; i<this.storelist.length; i++) {
        let rc = {
          RowType: "H",
          LocationID: this.storelist[i]['LocationID'],
          LocationName: this.storelist[i]['LocationID'] + " - " + this.storelist[i]['LocationName'],
          selected: 0,
          SourceType: "",
          IDn: -1,
          Menu_IDn: -1,
          AutoConfirm: -1,
        };
        if (menu.LocationID.indexOf(this.storelist[i]['LocationID']) !== -1) {
          rc.selected = 1;
        }
        let ol = this.onlineList[this.storelist[i]['LocationID']];
        let oltype = typeof ol;
        if ((oltype == 'object') && Array.isArray(ol) && (ol.length > 0)) {
          onlineStores.push(rc);
          for (let j = 0; j < ol.length; j++) {
            let rc1 = {
              RowType: "",    // Cloud Source Record
              LocationID: this.storelist[i]['LocationID'],
              LocationName: this.storelist[i]['LocationID'] + " - " + this.storelist[i]['LocationName'],
              selected: (this.cur_menu.IDn==ol[j].Menu_IDn)?1:0,
              SourceType: ol[j].SourceType,
              SourceName: ol[j].SourceName,
              IDn: parseInt(ol[j].IDn),
              Menu_IDn: parseInt(this.cur_menu.IDn),
              AutoConfirm: ol[j].AutoConfirm,
            };
            onlineStores.push(rc1);
          }
        } else {
          rc["RowType"] = "D";
          onlineStores.push(rc);
        }
      }
      this.onlineStoreList = onlineStores;
    },
    // re-get current menu data
    async getcur_menu() {
      this.showloading = true;
      // this will be called only after form is valid. You can do api call here to login
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("MenuIDn", this.cur_MenuIDn);

      var that = this;
      axios({
        method: "post",
        url: "/Api/Web/Menu/get_curent_menu",
        data: bodyFormData,
      })
        .then(function (response) {
          that.showloading = false;
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.cur_MenuIDn = rt.data.MenuIDn;
              that.storelist = rt.data.stores;
              var lt = typeof rt.data.menu.LocationID;
              if (lt != 'object') {
                rt.data.menu.LocationID = [];
              }
              that.cur_menu = rt.data.menu;
              that.curmenu_departmentlist = rt.data.menu_departments;
              that.onlineList = rt.data.onlineList;
              that.format_meun(that.cur_menu);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          } else {
            that.$router.push("/login");
          }
        })
        .catch(function (error) {
          console.log(error);
          that.$router.push("/login");
        });
    },
    change_cur_menu() {
      // console.log("MenuSetting.vue change_cur_menu");
      this.isChanged = true;
    },
    // Change to save current menu changes, reload???, redraw???
    changed_store(store) {
      // console.log("changed_store S", store.selected, JSON.parse(JSON.stringify(this.cur_menu.LocationID)));

      if (Array.isArray(this.cur_menu.LocationID)) {
        if (store.selected) {
          this.cur_menu.LocationID.push(store.LocationID);
        } else {
          const index = this.cur_menu.LocationID.indexOf(store.LocationID);
          if (index > -1) {
            this.cur_menu.LocationID.splice(index, 1);
          }
        }
      } else {
        if (store.selected) {
          this.cur_menu.LocationID = [store.LocationID];
        } else {
          this.cur_menu.LocationID = [];
        }
      }
      this.change_cur_menu();
    },
    async upload_online(event, store) {
      if (event) {
        event.preventDefault();
      }
      this.showloading = true;
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("IDn", store.IDn);
      var that = this;

      axios({
        method: "post",
        url: "/Api/Web/Store/uploadStoreData",
        data: bodyFormData,
      })
        .then(function (response) {
          that.showloading = false;
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              if (rt.data && rt.data.message) {
                that.text_message = rt.data.message;
                alert(that.text_message);
              } else if (rt.message) {
                that.text_message = rt.message;
                alert(that.text_message);
              } else {
                that.text_message = "Unknown return message";
                alert(that.text_message);
              }
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          that.showloading = false;
          // console.log(error);
          that.$router.push("/login");
        });
    },
    scrolldown(msg) {
      this.upload_file_list.push(msg);
      var container = this.$el.querySelector("#upload_product_ref");
      container.scrollTop = container.scrollHeight;
    },
    async upload_ldw_one() {
      var ProductIDn = this.upload_file_ids[this.upload_file_cnt];
      if ((ProductIDn == undefined) || (this.upload_file_cnt >= this.upload_file_ids.length)) {
        this.upload_show_close = true;
        // this.upload_product_dialog = false;
      }
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("ProductIDn", ProductIDn);

      var that = this;
      axios({
        method: "post",
        url: "/Api/Web/Pos_setting/uploadLdwImage",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.scrolldown(rt.data.message);
              that.upload_file_cnt++;
              that.upload_ldw_one();
            } else if (rt.status == 4) {
              that.upload_show_close = true;
              that.scrolldown("No Permission");
            } else if (rt.message != undefined) {
              that.upload_show_close = true;
              that.scrolldown(rt.message);
            }
          } else {
            that.upload_show_close = true;
            that.scrolldown("Upload Failured!!!");
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.upload_show_close = true;
          that.scrolldown("Upload Failured !!");
        });
    },
    async upload_ldw() {
      var msg = "";
      this.upload_file_list = [];
      this.upload_file_ids = [];
      this.upload_product_dialog = true;
      this.upload_show_close = false;

      for (var dmi = 0; dmi < this.curmenu_departmentlist.length; dmi++) {
        for (var cmi = 0; cmi < this.curmenu_departmentlist[dmi].Categorys.length; cmi++) {
          for (var pmi = this.curmenu_departmentlist[dmi].Categorys[cmi].Products.length - 1; pmi >= 0; pmi--) {
            var mprd = this.curmenu_departmentlist[dmi].Categorys[cmi].Products[pmi];
            this.upload_file_ids.push(mprd.ProductIDn);
          }
        }
      }
      this.upload_file_cnt = 0;
      this.upload_ldw_one();
    },
    save_ordernum(MenuIDn, ordernum) {
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("MenuIDn", MenuIDn);
      bodyFormData.append("menuOrder", ordernum);

      var that = this;
      axios({
        method: "post",
        url: "/Api/Web/menu/save_menu_order",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              ;
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        });
    },
    swapObjects(array, index1, index2) {
      const temp = array[index1];
      array[index1] = array[index2];
      array[index2] = temp;
      return array;
    },
    move_action(idx, to) {
      // console.log("move_action", idx, to);
      let newlist = JSON.parse(JSON.stringify(this.menulist));
      let maxidx = newlist.length;
      let nextidx = idx + to;
      if ((nextidx < 0) || (nextidx >= maxidx)) {
        return;
      }
      let curOrder = newlist[idx].menuOrder;
      newlist[idx].menuOrder = newlist[nextidx].menuOrder;
      newlist[nextidx].menuOrder = curOrder;
      this.save_ordernum(newlist[idx].IDn, newlist[idx].menuOrder);
      this.save_ordernum(newlist[nextidx].IDn, newlist[nextidx].menuOrder);
      if (this.cur_MenuIDn == newlist[idx].IDn) {
        this.cur_menu.menuOrder = newlist[idx].menuOrder;
      } else if (this.cur_MenuIDn == newlist[nextidx].IDn) {
        this.cur_menu.menuOrder = newlist[nextidx].menuOrder;
      }
      this.menulist = this.swapObjects(newlist, idx, nextidx);
    },
    async get_menu_list() {
      // this will be called only after form is valid. You can do api call here to login
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("MenuIDn", this.cur_MenuIDn);

      var that = this;
      axios({
        method: "post",
        url: "/Api/Web/Menu",
        data: bodyFormData,
      })
        .then(function (response) {
          that.showloading = false;
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              if (rt.data.menus) {
                try {
                  that.menulist = rt.data.menus;
                  // that.menulist = rt.data.menus.sort((a, b) => (a.menuOrder - b.menuOrder));
                  // let minorder = that.menulist[0].menuOrder;
                  // for (let i = 1; i < that.menulist; i++) {
                  //   if (minorder < that.menulist[i].menuOrder) {
                  //     minorder = that.menulist[i].menuOrder;
                  //   } else {
                  //     minorder++;
                  //     that.menulist[i].menuOrder = minorder;
                  //     that.save_ordernum(that.menulist[i].IDn, minorder)
                  //   }
                  // }
                } catch (err) {
                  console.log(" MenuSetting.vue get_menu_list error", err);
                }
              }
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          } else {
            that.$router.push("/login");
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        });
    },
    async init_data() {
      this.token = getStore("token");
      this.user_id = getStore("user_id");
      let name = getStore("username");
      this.cur_MenuIDn = this.$route.query.menu_id;

      if (name && name != undefined && ((name == "PKAdmin") || (name == "posking"))) {
        this.pkadmin = true;
      }

      if (!this.token || !this.user_id) {
        this.$router.push("/login");
        return;
      }
      this.get_menu_list();
      return this.getcur_menu();
    },
  },
  mounted() {
    this.windowHeight = window.innerHeight;
    this.init_data();
  },
};
</script>
<style scoped>
.menu-sort-block {
  display: flex;
  width: 100%;
  justify-content: center;
}
.opt-class {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: 1.5rem;
}
.opt-class:hover {
  cursor: pointer;
}
.name-class {
  flex: 4;
  display: flex;
  justify-content: center;
  align-items: center;
}
.content {
  padding-top: 80px;
}
.template-class {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.template-sub {
  width: 10rem;
  height: 6.5rem;
  margin: 0.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.left_menu_font {
  font-size: .8rem;
}
.left_menu_font .border-dark {
  border-color: #bbbbbb !important;
  font-weight: bold;
  position: relative;
}
.department_div {
  border: 1px solid #bbbbbb;
  width: 100%;
  height: 80px;
  overflow: auto;
  position: relative;
  margin-bottom: .1rem;
}
.department_div2 {
  border: 1px solid #bbbbbb;
  width: 100%;
  height: 60px;
  overflow: auto;
  position: relative;
  margin-bottom: .1rem;
}
.category_div {
  border: 1px solid #bbbbbb;
  width: 100%;
  overflow: auto;
  position: relative;
  height: 120px;
  margin-bottom: .1rem;
}
.category_div2 {
  border: 1px solid #bbbbbb;
  width: 100%;
  overflow: auto;
  position: relative;
  height: 144px;
  margin-bottom: .1rem;
}
.product_div {
  border: 1px solid #bbbbbb;
  width: 100%;
  overflow: auto;
  position: relative;
  height: 460px;
}
.product_div2 {
  border: 1px solid #bbbbbb;
  width: 100%;
  overflow: auto;
  position: relative;
  height: 306px;
}
.department_button {
  padding-top: 20px;
  width: 100%;
  height: 100px;
  overflow: auto;
  position: relative;
}
.department_button2 {
  padding-top: 8px;
  width: 100%;
  height: 66px;
  overflow: auto;
  position: relative;
}
.category_button {
  padding-top: 70px;
  width: 100%;
  height: 220px;
  overflow: auto;
  position: relative;
}
.category_button2 {
  padding-top: 44px;
  width: 100%;
  height: 147px;
  overflow: auto;
  position: relative;
}
.product_button {
  padding-top: 140px;
  width: 100%;
  height: 600px;
  overflow: auto;
  position: relative;
}
.product_button2 {
  padding-top: 96px;
  width: 100%;
  height: 400px;
  overflow: auto;
  position: relative;
}
.department_list {
  background: #e0e0e0;
}
.menulabel {
  font-size: 14px;
}
.category_list {
  background: #e0e0e0;
}
.product_list {
  background: #e0e0e0;
}
.meun_pad_list {
  padding-left: 0px;
  padding-right: 0px;
}
.search-button {
  margin-top: 2rem;
}
.card .table td {
  padding: 0.5rem;
}
.product_select {
  background: #e0e0e0;
  border: 2px solid #bbbbbb;
  border-radius: 5px;
  height: 24rem;
  margin-bottom: 1rem;
  overflow: auto;
}
.page_hr {
  margin: 0px;
}
.product {
  color: #202020;
}
.panel-middle {
  width: 20px;
}
.panel-middle2 {
  width: 8px;
}
.pad_panel {
  width: 674px;
  height: 663px;
  background: chartreuse;
  line-height: 14px;
}
.pad_panel2 {
  width: 445px;
  height: 440px;
  background: chartreuse;
  line-height: 7px;
}
.panel_list {
  height: 10px;
  width: 100%;
  background: #e0e0e0;
  border-radius: 5px;
  border: 1px none;
  overflow: auto;
  position: relative;
}
.left_panel_sm_font {
  font-size: 0.5rem;
}
.hr-line {
  width: 100%;
  height: 3px;
  cursor: row-resize;
  background: #ffffff;
  color: #ffffff;
  border-top: 1px solid #606060;
  border-bottom: 1px solid #606060;
  border-right: none;
  border-left: none;
  position: relative;
}
.colorsquire {
  width: 24px;
  height: 24px;
  margin-left: 6px;
  display: inline-block;
  border-radius: 5px;
  box-shadow: 2px 2px #606060;
}
.menu-button-color {
  top: 8px;
}
.el-input-number--mini {
  width: 95px;
}
.menupage .el-form-item,.el-form-item--small {
  margin-bottom: 0px;
}
.menupage .widthdate {
  width: 60%;
}
.menupage .el-select {
  width: 95px;
}
.menupage .leftmenuitem {
  cursor: pointer;
}
.upload_ldw {
  margin-left: 2rem;
}
.upload_product_div {
  height: 10rem;
  overflow: scroll;
}
</style>
